/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdCascaderProps } from './type';

export const cascaderDefaultProps: TdCascaderProps = {
  borderless: false,
  checkStrictly: false,
  clearable: false,
  filterable: false,
  lazy: true,
  loading: false,
  max: 0,
  minCollapsedNum: 0,
  multiple: false,
  options: [],
  placeholder: undefined,
  readonly: false,
  reserveKeyword: true,
  showAllLevels: true,
  size: 'medium',
  status: 'default',
  trigger: 'click',
  defaultValue: [],
  valueMode: 'onlyLeaf',
  valueType: 'single',
};
